import React from 'react';

const Task = () => {
	return <div className='task'>task</div>;
};

export default Task;
